<!--
 * @Description: 用户名密码/手机号验证码登录
 * @Author: l_hc
 * @LastEditors: l_hc
 * @Date: 2019-07-04 21:29:57
 * @LastEditTime: 2019-07-29 13:34:18
 -->
<template>
  <div>
    <el-tabs v-model="activeName">
      <el-tab-pane v-for="(item, index) in tabs.list" :key="index" :label="item.label" :name="item.component">
        <div class="content">
          <component :is="item.component" :ref="item.component" @login="loginFn(item.component)" />
        </div>
      </el-tab-pane>
      <el-row>
        <el-button class="button" :loading="loading" @click="loginFn">登录</el-button>
      </el-row>
      <div class="bottom">
        <!--<div>-->
        <!--<el-checkbox v-show="activeName !== 'PhoneCodeLogin'" v-model="checked">记住密码</el-checkbox>-->
        <!--</div>-->
        <router-link class="login-reg-link" :to="{name: 'Reg'}">注册</router-link>
      </div>
    </el-tabs>
  </div>
</template>

<script>
import UserNameLogin from './UserNameLogin'
import PhoneCodeLogin from './PhoneCodeLogin'
// import Vue from 'vue'
// import dragVerify from 'vue-drag-verify'
// Vue.use(dragVerify)
export default {
  name: 'Log',
  components: { UserNameLogin, PhoneCodeLogin },
  data() {
    return {
      // tabs
      tabs: {
        list: [{
          label: '密码登录',
          component: 'UserNameLogin'
        }, {
          label: '短信登录',
          component: 'PhoneCodeLogin'
        }]
      },
      checked: false,
      // 默认显示密码登录
      activeName: 'UserNameLogin',
      loading: false
    }
  },
  mounted() {
    document.onkeydown = (e) => {
      // console.log(e)
      if (e.keyCode === 13) {
        this.loginFn()
      }
    }
  },
  methods: {
    // 登录函数
    loginFn() {
      const activeName = this.activeName
      const loginForm = this.$refs[activeName][0]
      const formData = loginForm.validateForm() // 获取验证结果
      if (!formData === false) { // 不等于false 验证成功并且返回数据对象
        activeName === 'UserNameLogin' ? this.userNamaLogin(formData) : this.PhoneCodeLogin(formData)
      }
    },
    // 用户名密码登录
    userNamaLogin(formData) {
      if (this.loading == false) {
        this.loading = true
        this.$store
          .dispatch('user/login', formData)
          .then((e) => {
             console.log("123123")
            this.loading = false
            this.$router.push({ path: this.redirect || '/' })
          })
          .catch(err => {
            console.log(err)
            console.log(err.response)
            if (err.response == undefined) {
              this.$message({
                message: '用户名密码错误',
                type: 'warning'
              })
            }
            this.loading = false
            this.$refs.UserNameLogin[0].changeCode()
          })
      }
    },
    // 手机号验证码登录
    PhoneCodeLogin(formData) {
      console.log(formData)
      this.loading = true
      this.$store
        .dispatch('user/phoneLogin', formData)
        .then(() => {
          this.loading = false
          this.$router.push({ path: this.redirect || '/' })
        })
        .catch(() => {
          this.loading = false
        })
    }
  }

}
</script>

<style scoped lang='scss'>
// content
.content {
  margin-top: 25px;
}
.bottom {
  display: flex;
  justify-content: space-between;
  float: right;
}
</style>
